module.exports = __webpack_public_path__ + "static/media/imgHome_CardUs_Mobile.b3cce6a8.png";